import { usePostHog } from 'posthog-js/react';
import { useCallback } from 'react';

export const useAnalytics = () => {
  const posthog = usePostHog();

  /**
   * Track a custom event in PostHog
   * @param eventName Name of the event
   * @param properties Optional properties to include
   */
  const trackEvent = useCallback((eventName: string, properties?: Record<string, any>) => {
    posthog.capture(eventName, properties);
  }, [posthog]);

  /**
   * Get the variant of a feature flag / A/B test
   * @param flagKey The key of the feature flag
   * @returns The variant value (string, boolean, or undefined)
   */
  const getVariant = useCallback((flagKey: string) => {
    return posthog.getFeatureFlag(flagKey);
  }, [posthog]);

  /**
   * Check if a feature flag is enabled
   * @param flagKey The key of the feature flag
   * @returns boolean
   */
  const isFeatureEnabled = useCallback((flagKey: string) => {
    return posthog.isFeatureEnabled(flagKey);
  }, [posthog]);

  /**
   * Track a page view manually (if needed)
   */
  const trackPageView = useCallback(() => {
    posthog.capture('$pageview');
  }, [posthog]);

  return {
    trackEvent,
    getVariant,
    isFeatureEnabled,
    trackPageView,
    posthog, // Expose full posthog instance for advanced usage
  };
};
